// Time comes in as 600, 1300, etc.
// We want to return 6:00, 13:00 etc.
export default function formatTimeFilter(timeStr: string) {
  const timeNumber = Number(timeStr)
  if (isNaN(timeNumber)) return null

  const hours = Math.floor(timeNumber / 100)

  const now = new Date()
  now.setHours(hours)
  now.setMinutes(0)

  return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
}
